'use client';

import { useCookieConsent } from '@/components/layout/CookieConsent/CookieConsentProvider';
import { Button } from '@/components/primitives/Button';
import { isAnalyticsActive } from '@/lib/analytics/config';

type ManageCookiePreferencesButtonProps = {
  label: string;
};

export function ManageCookiePreferencesButton({
  label,
}: ManageCookiePreferencesButtonProps) {
  const { openBanner } = useCookieConsent();

  if (!isAnalyticsActive()) return null;

  return (
    <Button type="button" variant="primary" colour="blue" size="large" onClick={openBanner}>
      {label}
    </Button>
  );
}
